const _loadingStatus = {
  NONE: 'None',
  LOADING: 'Loading',
  SUCCESS: 'Success',
  FAILED: 'Failed',
};

export default Object.freeze(_loadingStatus);
